// The Animation drawer in EditorApp is a flex column of two cards: the
// selection card (header + Giriş/Çıkış tabs + preset grid, scrolls
// internally) and, while a Pan preset is being edited, the detached pan card
// (duration/seconds slider first, then direction, zoom, start point; also
// scrolls internally). The drawer's height is what is left above the timeline,
// so on a laptop — or with the timeline dragged taller — it gets short.
//
// The floors below decide who gives way. With the selection card pinned at
// its one-row floor and the pan card at 0, all the shrinking came out of the
// pan card: on a 1366x768 screen it was left 50px tall, and with a taller
// timeline it vanished, so the seconds slider only showed up after zooming the
// browser out. While the pan card is open it is the thing being edited, so it
// keeps its first section and the selection card yields down to header + tabs.

// Measured rendered heights (Chrome), kept as constants the same way
// RightPanelShell's HEADER_HEIGHT is.
// .ap-tabs: button 27 + padding 3+3 = 32, + margin-bottom 10.
export const ANIMATION_TABS_HEIGHT = 42;
// .ap-pan-controls padding-top 10 + .ap-pan-label 14 + gap 5 + .ap-duration-row
// 27 = 56 to the bottom of the seconds row, + 10 so it doesn't sit on the edge.
export const PAN_CARD_MIN_HEIGHT = 66;
// Header + tabs + one row of preset cards, used while the pan card is closed.
export const SELECTION_CARD_MIN_HEIGHT = 190;
// The drawer's flex `gap` between the two cards.
export const DRAWER_STACK_GAP = 12;

/**
 * Min heights for the drawer's two cards.
 *
 * @param {object} p
 * @param {boolean} p.panCardOpen  a Pan preset is selected and its settings
 *   card is not collapsed (EditorApp: animPanActive && !animPanCollapsed)
 * @param {number} p.headerHeight  RightPanelShell's rendered header height
 * @returns {{ selection: number, pan: number }}
 */
export function animationDrawerStackFloors({ panCardOpen, headerHeight }) {
  if (panCardOpen) {
    return { selection: headerHeight + ANIMATION_TABS_HEIGHT, pan: PAN_CARD_MIN_HEIGHT };
  }
  return { selection: Math.max(headerHeight, SELECTION_CARD_MIN_HEIGHT), pan: 0 };
}
